import { page } from "@randajan/jet-react/base/page";
import tab from "@randajan/jet-react/base/tab";

// tab.set("srcTag", page.pull("search.srcTag"));
// tab.set("voucher", page.pull("search.voucher"));


window.page = page;
